import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import icon11 from "../Icons/Icon-11.png";
import icon12 from "../Icons/Icon-12.png";
import icon13 from "../Icons/Icon-13.png";
import icon14 from "../Icons/Icon-14.png";
import icon15 from "../Icons/Icon-15.png";
import icon16 from "../Icons/Icon-16.png";
import './Contact.css';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import contactImage from '../images/WhatsApp Image 2024-11-11 at 15.57.57_43af8a21.jpg';
import { useSelector } from 'react-redux';
import { showRegister } from "../Redux/HomeSlice";
import { useDispatch } from 'react-redux'
import Register from "../Register/Register";
import Searsh from '../Searsh/Searsh'
function Contact() {
    const dispatch = useDispatch();
    const { t } = useTranslation();    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSendEmail = (e) => {
        e.preventDefault();
        const mailtoLink = `mailto:Contact@ashtiri.com?subject=${t('contact_us')} - ${encodeURIComponent(name)}&body=${t('email')}: ${encodeURIComponent(email)}%0D%0A${t('your_message')}: ${encodeURIComponent(message)}`;
        window.location.href = mailtoLink;
    };

    const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  
    const getLocalStorage = window.localStorage.getItem("UserInfo");
    const valueLocalStorage = getLocalStorage
      ? JSON.parse(getLocalStorage)
      : null;
    const token =
      valueLocalStorage?.data?.token ||
      valueLocalStorage?.data?.data?.user?.token ||
      null;
  
    const showR = useSelector((state) => state?.products?.showR);
  
  
    const Sign_Up = (event) => {
      if (!token) {
        const { pageY } = event;
        const offsetY = -1200;
        setPopupPosition({ x: 50, y: pageY + offsetY });
        dispatch(showRegister(true));
      }
    };

    const show_searsh = useSelector((state) => state?.products?.searsh);

    
    return (
        <div className='About'>
            <Header />
            {showR && (
                <div className="overlay">
                    <div
                        className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4 mx-auto g-0"
                        style={{
                        position: "absolute",
                        top: `${popupPosition.y}px`,
                        left: "50%",
                        transform: "translateX(-50%)",
                        margin: "auto",
                        zIndex: 4,
                        padding: "0px",
                        }}
                    >
                        <Register />
                    </div>
                </div>
            )}
            {show_searsh && (
              <Searsh />
            )}
            <div className="contact-page">
                <div className="contact-background">
                    <img src={contactImage} alt="Contact Background" className="background-image" />
                </div>
                <div className="contact-container">
                    <h2>{t('contact_us')}</h2>
                    <p>{t('support_text')}</p>
                    <form className="contact-form" onSubmit={handleSendEmail}>
                        <input 
                            type="text" 
                            name="name" 
                            placeholder={t('name')} 
                            required 
                            value={name} 
                            onChange={(e) => setName(e.target.value)} 
                        />
                        <input 
                            type="email" 
                            name="email" 
                            placeholder={t('email')} 
                            required 
                            value={email} 
                            onChange={(e) => setEmail(e.target.value)} 
                        />
                        <textarea 
                            name="message" 
                            placeholder={t('your_message')} 
                            required 
                            value={message} 
                            onChange={(e) => setMessage(e.target.value)} 
                        />
                        <button type="submit">{t('send_message')}</button>
                    </form>
                    <div className="contact-info">
                        <p><FontAwesomeIcon icon={faPhone} /> {t('phone')}: +123456789</p>
                        <p><FontAwesomeIcon icon={faEnvelope} /> info@example.com</p>
                        <p><FontAwesomeIcon icon={faMapMarkerAlt} /> {t('address')}: شارع المثال، المدينة</p>
                    </div>
                    <div className='social-media-icons'>
                        <a href="https://www.facebook.com/profile.php?id=61561822240808">
                            <img src={icon11} alt='facebook'/>
                        </a>
                        <a href="https://www.instagram.com/ashtiri.kw?igsh=a3IwYmMwOHZyejBk">
                            <img src={icon12} alt='instagram'/>
                        </a>
                        <a href="https://x.com/Ashtiri_KW">
                            <img src={icon13} alt='x'/>
                        </a>
                        <a href="">
                            <img src={icon14} />
                        </a>
                        <a href="https://www.youtube.com/channel/UC6fL1RWQeDE8S5HAoKB7vGw">
                            <img src={icon15} alt='youtube'/>
                        </a>
                        <a href="https://www.pinterest.com/Ashtiri/">
                            <img src={icon16} alt='pinterest'/>
                        </a>
                    </div> 
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Contact;